const YEARS = ['0', '1-3', '4-7', '8-10', '11-14', '15-25', '26-30', '31+'];
export default YEARS;
export const EXPERIENCE = {
    '1-3': [1, 3],
    '4-7': [4, 7],
    '8-10': [8, 10],
    '11-14': [11, 14],
    '15-25': [15, 25],
    '26-30': [26, 30],
    '31+': [31, 100],
};

export const EXPERIENCE_LABELS = {
    '1-3': '1-3',
    '4-7': '4-7',
    '8-10': '8-10',
    '11-14': '11-14',
    '15-25': '15-25',
    '26-30': '26-30',
    '31+': '31+',
};
